import { Box } from '@branch-messenger/willow-ui'
import { yupResolver } from '@hookform/resolvers/yup'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'

import {
  CardSelectionSchema,
  cardSelectionSchema,
} from '@/containers/onDemandPay/TakeAdvance/lib/schemas/card-selection-schema'
import { useTakeAdvance } from '@/containers/onDemandPay/TakeAdvance/TakeAdvanceContext'
import { onDemandPayCardQueryOptions } from '@/queries/card'
import { ConnectedCardSelection } from '@/types/card'

import {
  AdvanceStepTitle,
  TakeAdvanceContentContainer,
  TakeAdvanceFooterButton,
} from '../../styles'
import { TakeAdvanceContent } from '../../TakeAdvanceContent'
import { TakeAdvanceFooter } from '../../TakeAdvanceFooter'
import { SelectDestinationCard } from './SelectDestinationCard'

export const AdvanceDestinationContent = () => {
  const { takeAdvanceValues, nextStep, setTakeAdvanceValues } = useTakeAdvance()
  const { data: onDemandPayCard } = useSuspenseQuery(
    onDemandPayCardQueryOptions()
  )
  const {
    watch,
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<CardSelectionSchema>({
    resolver: yupResolver(cardSelectionSchema),
  })

  const connectedCards: ConnectedCardSelection[] = [
    onDemandPayCard && { ...onDemandPayCard, type: 'EWA_CARD' },
  ].filter((card): card is ConnectedCardSelection => card !== null)

  const handleCardSelection = (data: CardSelectionSchema) => {
    setTakeAdvanceValues({
      ...takeAdvanceValues,
      card_type: data.card_type,
    })
    nextStep()
  }

  return (
    <TakeAdvanceContentContainer
      as="form"
      onSubmit={handleSubmit(handleCardSelection)}
    >
      <TakeAdvanceContent>
        <Box $display="flex" $direction="column" $align="initial" $gap={6}>
          <AdvanceStepTitle>{`Choose advance destination.`}</AdvanceStepTitle>
          <SelectDestinationCard
            cards={connectedCards}
            selectedCardType={watch('card_type')}
            control={control}
          />
        </Box>
      </TakeAdvanceContent>
      <TakeAdvanceFooter>
        <TakeAdvanceFooterButton type="submit" disabled={!isValid}>
          Continue
        </TakeAdvanceFooterButton>
      </TakeAdvanceFooter>
    </TakeAdvanceContentContainer>
  )
}
